// extracted by mini-css-extract-plugin
export default {"reportExt":"JP_ReportCSR_reportExt__XH7eC"};